import { message } from "antd";

export const handleFileFolderMutation = (state, action) => {
  const { tenant_id, folder_id, type, workbook_id } = action.meta.arg;
  const { data, message: apiMessage } = action.payload;

  const tenantFolders = state.foldersByTenants[tenant_id];

  if (type === "delete") {
    if (workbook_id) {
      const folder = tenantFolders[folder_id || null];

      if (folder?.workbooks) {
        folder.workbooks = folder.workbooks.filter(
          (item) => item.id !== workbook_id,
        );
      }
    } else {
      delete tenantFolders[folder_id];
    }
  } else if (type === "rename") {
    if (workbook_id) {
      const folder = tenantFolders[folder_id || null];

      const workbook = folder?.workbooks?.find(
        (item) => item.id === workbook_id,
      );

      if (workbook) {
        workbook.name = data?.name;
      }
    } else {
      const folder = tenantFolders[data?.id || folder_id];

      if (folder) folder.name = data?.name;
    }
  } else if (type === "folder") {
    tenantFolders[data?.id || null] = {
      ...data,
      workbooks: [],
    };
  } else {
    const key = folder_id || null;

    tenantFolders[key] ??= {
      folder_id: null,
      name: null,
      workbooks: [],
    };

    tenantFolders[key].workbooks.unshift({
      ...data,
      role: "owner",
    });
  }

  message.success(apiMessage || "Added successfully!");
};
